import styled from 'styled-components';
import { tokens } from 'styling/tokens';
import { TitleText } from 'styling/Typography';

export const Container = styled.div`
  width: 100%;
  background: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});
  border: 1px solid ${tokens.border.hairline};
  box-shadow: ${tokens.shadow.card};
  overflow: hidden;
  border-radius: ${tokens.radius.card};
`

export const ContainerHeader = styled.div<{ padding?: boolean }>`
  background: transparent;
  border-bottom: 1px solid ${tokens.border.hairline};
  border-radius: 0px 16px 0px 0px;
  width: 100%;
  height: 50px;
  display: flex;
  padding: 0 1rem;
  display: flex;
align-items: center;
 ${(props) => props.padding && 'padding:1rem; height:auto;'}

  ${TitleText} {
    font-size: 0.85rem;
    font-weight: 700;
    color: ${tokens.text.primary};
  }
`


export const ContainerContent = styled.div<{ gap?: string }>`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px - 1rem);
  gap: ${(props) => props.gap || '0rem'};
`

export const ContainerOptions = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        height: 100%;
        position: relative;
        aspect-ratio: 1/1;
`
